import React from 'react';
import Box from '@mui/material/Box';
import { Svg } from 'components';
import { AppLink, AppWrapper, SocialLink } from './styled';
import { appLinks, socialLinks } from './AppsAndSocialsData';

function AppsAndSocials(): JSX.Element {
  return (
    <Box
      sx={{
        margin: 'auto',
        textAlign: { xs: 'center', sm: 'center', md: 'left', lg: 'left' }
      }}>
      <AppWrapper>
        {appLinks.map((app) => (
          <AppLink
            data-testid={`app-${app.iconName}`}
            key={app.iconName}
            rel={app.rel}
            href={app.linkURL}
            target={app.target}>
            <Svg name={app.iconName} height="33px" width="110px" />
          </AppLink>
        ))}
      </AppWrapper>
      <div>
        {socialLinks.map((social) => (
          <SocialLink
            data-testid={`app-${social.iconName}`}
            key={social.iconName}
            rel={social.rel}
            href={social.linkURL}
            target={social.target}>
            <Svg name={social.iconName} height="28px" width="28px" />
          </SocialLink>
        ))}
      </div>
    </Box>
  );
}

export default AppsAndSocials;
